import { defineMessage } from '@lingui/macro';

const UNCLAIMED = 'UNCLAIMED',
  CLAIMED = 'CLAIMED',
  APPROVED = 'APPROVED',
  UNAPPROVED = 'UNAPPROVED',
  REJECTED = 'REJECTED',
  BLOCKED = 'BLOCKED',
  PLANNED = 'PLANNED',
  UNPLANNED = 'UNPLANNED',
  BLOCK_RESOLVED = 'BLOCK_RESOLVED',
  READY_TO_WELD = 'READY_TO_WELD',
  SENT_BACK_TO_PIPING = 'SENT_BACK_TO_PIPING',
  VT_APPROVED = 'VT_APPROVED',
  VT_SENT_BACK = 'VT_SENT_BACK',
  FITUP_INSPECTION = 'FITUP_INSPECTION',
  FITUP_REQUESTED = 'FITUP_REQUESTED',
  ASSIGNED = 'ASSIGNED',
  RECLAIMED = 'RECLAIMED',
  BLOCK_OPENED = 'BLOCK_OPENED',
  REQUESTED = 'REQUESTED',
  CANCELED = 'CANCELED',
  NOT_APPLICABLE = 'NOT_APPLICABLE';

export const MilestoneStatusMessages = {
  [UNCLAIMED]: defineMessage({ message: 'Unclaimed', id: 'Unclaimed' }),
  [CLAIMED]: defineMessage({ message: 'Claimed', id: 'Claimed' }),
  [APPROVED]: defineMessage({ message: 'Approved', id: 'Approved' }),
  [UNAPPROVED]: defineMessage({ message: 'Unapproved', id: 'Unapproved' }),
  [REJECTED]: defineMessage({ message: 'Rejected', id: 'Rejected' }),
  [BLOCKED]: defineMessage({ message: 'Blocked', id: 'Blocked' }),
  [PLANNED]: defineMessage({ message: 'Planned', id: 'Planned' }),
  [UNPLANNED]: defineMessage({ message: 'Unplanned', id: 'Unplanned' }),
  [BLOCK_RESOLVED]: defineMessage({ message: 'Block Resolved', id: 'Block_Resolved' }),
  [READY_TO_WELD]: defineMessage({ message: 'Ready to Weld', id: 'READY_TO_WELD' }),
  [SENT_BACK_TO_PIPING]: defineMessage({ message: 'Sent Back to Piping', id: 'SENT_BACK_TO_PIPING' }),
  [VT_APPROVED]: defineMessage({ message: 'VT Approved', id: 'VT_APPROVED' }),
  [VT_SENT_BACK]: defineMessage({ message: 'VT Sent Back', id: 'VT_SENT_BACK' }),
  [FITUP_INSPECTION]: defineMessage({ message: 'Fitup Inspection', id: 'FITUP_INSPECTION' }),
  [ASSIGNED]: defineMessage({ message: 'Assigned', id: 'ASSIGNED' }),
  [REQUESTED]: defineMessage({ message: 'Requested', id: 'REQUESTED' }),
  [NOT_APPLICABLE]: defineMessage({ message: 'Not Applicable', id: 'NOT_APPLICABLE' }),
  [CANCELED]: defineMessage({ message: 'Canceled', id: 'CANCELED' }),
};

export const WeldStatusMessages = {
  [CLAIMED]: defineMessage({ message: 'Claimed', id: 'Claimed' }),
  [APPROVED]: defineMessage({ message: 'VT Approved', id: 'VT Approved' }),
  [REJECTED]: defineMessage({ message: 'Rejected', id: 'Rejected' }),
  [BLOCKED]: defineMessage({ message: 'Blocked', id: 'Blocked' }),
  [PLANNED]: defineMessage({ message: 'Assigned/Planned', id: 'Assigned/Planned' }),
  [READY_TO_WELD]: defineMessage({ message: 'Ready to Weld', id: 'READY_TO_WELD' }),
  [VT_SENT_BACK]: defineMessage({ message: 'VT Sent Back', id: 'VT_SENT_BACK' }),
  [FITUP_INSPECTION]: defineMessage({ message: 'Fitup Inspection', id: 'FITUP_INSPECTION' }),
  [ASSIGNED]: defineMessage({ message: 'Assigned', id: 'ASSIGNED' }),
  [VT_APPROVED]: defineMessage({ message: 'VT Approved', id: 'VT_APPROVED' }),
  [SENT_BACK_TO_PIPING]: defineMessage({ message: 'Sent Back to Piping', id: 'SENT_BACK_TO_PIPING' }),
  [FITUP_REQUESTED]: defineMessage({ message: 'Fitup Requested', id: 'FITUP_REQUESTED' }),
};

const NONE = 'NONE',
  FOREMAN = 'FOREMAN',
  GENERAL_FOREMAN = 'GENERAL_FOREMAN',
  SUPERINTENDENT = 'SUPERINTENDENT',
  FIELD_ENGINEER = 'FIELD_ENGINEER',
  CRAFT = 'CRAFT',
  SUPER_USER = 'SUPER_USER',
  SUPER_ADMIN = 'SUPER_ADMIN',
  Staged = 'Staged',
  PROJECT_ADMIN = 'PROJECT_ADMIN',
  NON_INTERACTIVE_ACCOUNT = 'NON_INTERACTIVE_ACCOUNT',
  FIELD_WELD_ENGINEER = 'FIELD_WELD_ENGINEER',
  ROD_ROOM_ATTENDANT = 'ROD_ROOM_ATTENDANT';

export const PersonaMessages = {
  [NONE]: defineMessage({ message: 'NONE', id: 'NONE' }),
  [FOREMAN]: defineMessage({ message: 'FOREMAN', id: 'FOREMAN' }),
  [GENERAL_FOREMAN]: defineMessage({ message: 'GENERAL FOREMAN', id: 'GENERAL_FOREMAN' }),
  [SUPERINTENDENT]: defineMessage({ message: 'SUPERINTENDENT', id: 'SUPERINTENDENT' }),
  [FIELD_ENGINEER]: defineMessage({ message: 'FIELD ENGINEER', id: 'FIELD_ENGINEER' }),
  [CRAFT]: defineMessage({ message: 'CRAFT', id: 'CRAFT' }),
  [Staged]: defineMessage({ message: 'Staged', id: 'Staged' }),
  [SUPER_USER]: defineMessage({ message: 'SUPER USER', id: 'SUPER_USER' }),
  [SUPER_ADMIN]: defineMessage({ message: 'SUPER ADMIN', id: 'SUPER_ADMIN' }),
  [PROJECT_ADMIN]: defineMessage({ message: 'PROJECT ADMIN', id: 'PROJECT_ADMIN' }),
  [NON_INTERACTIVE_ACCOUNT]: defineMessage({
    message: 'NON INTERACTIVE ACCOUNT',
    id: 'NON_INTERACTIVE_ACCOUNT',
  }),
  [ROD_ROOM_ATTENDANT]: defineMessage({ message: 'Rod Room Attendant', id: 'ROD_ROOM_ATTENDANT' }),
  [FIELD_WELD_ENGINEER]: defineMessage({ message: 'Field Weld Engineer', id: 'FIELD_WELD_ENGINEER' }),
};

export const MilestoneActivityMessages = {
  [PLANNED]: defineMessage({ message: 'Planned', id: 'Planned' }),
  [UNPLANNED]: defineMessage({ message: 'Unplanned', id: 'Unplanned' }),
  [CLAIMED]: defineMessage({ message: 'Claimed', id: 'Claimed' }),
  [UNCLAIMED]: defineMessage({ message: 'Unclaimed', id: 'Unclaimed' }),
  [REJECTED]: defineMessage({ message: 'Rejected', id: 'Rejected' }),
  [RECLAIMED]: defineMessage({ message: 'Reclaimed', id: 'Reclaimed' }),
  [APPROVED]: defineMessage({ message: 'Approved', id: 'Approved' }),
  [UNAPPROVED]: defineMessage({ message: 'Unapproved', id: 'Unapproved' }),
  [BLOCK_OPENED]: defineMessage({ message: 'Blocked', id: 'Blocked' }),
  [BLOCK_RESOLVED]: defineMessage({ message: 'Block Resolved', id: 'Block_Resolved' }),
  [REQUESTED]: defineMessage({ message: 'Requested', id: 'REQUESTED' }),
  [NOT_APPLICABLE]: defineMessage({ message: 'Not Applicable', id: 'NOT_APPLICABLE' }),
  [CANCELED]: defineMessage({ message: 'Canceled', id: 'CANCELED' }),
};
